import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const editarMenu = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/menus/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar menu';
    throw new Error(errorMessage);
  }
};

export const obterMenu = async (id: number) => {
  try {
    const response = await api.get(`/menus/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter menu';
    throw new Error(errorMessage);
  }
};

export const listarMenus = async () => {
  try {
    const response = await api.get(`/menus/listar`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar menus';
    throw new Error(errorMessage);
  }
};